import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LmsContentComponent } from './lms-content/lms-content.component';
import { LmsContentEditiorComponent } from './lms-content-editior/lms-content-editior.component';
import { LmsLayoutComponent } from './lms-layout/lms-layout.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ArchwizardModule } from 'angular-archwizard';
import { FormsRoutingModule } from 'app/forms/forms-routing.module';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { DragulaModule } from 'ng2-dragula';
import { TagInputModule } from 'ngx-chips';
import { CustomFormsModule } from 'ngx-custom-validators';
import { QuillModule } from 'ngx-quill';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UiSwitchModule } from 'ngx-ui-switch';
import { PipeModule } from 'app/shared/pipes/pipe.module';

const routes: Routes = [
  { path: 'student-lms', component: LmsLayoutComponent },
  { path: 'course/:slug', component: LmsLayoutComponent },
  { path: 'content', component: LmsContentComponent },
  // { path: 'edit-content', component: LmsContentEditorComponent },
  // { path: 'edit-video', component: LmsContentEditorComponent },

];

@NgModule({
  declarations: [
    LmsContentComponent,
    LmsContentEditiorComponent,
    LmsLayoutComponent
  ],
  imports: [
    CommonModule,
    DragulaModule.forRoot(),
    FormsRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    ArchwizardModule,
    CustomFormsModule,
    MatchHeightModule,
    UiSwitchModule,
    QuillModule.forRoot(),
    NgSelectModule,
    TagInputModule,
    MatMenuModule,
    DragDropModule,
    RouterModule.forChild(routes),
    // NgCircleProgressModule.forRoot({
    //   // set defaults here
    //   radius: 100,
    //   outerStrokeWidth: 16,
    //   innerStrokeWidth: 8,
    //   outerStrokeColor: "#78C000",
    //   innerStrokeColor: "#C7E596",
    //   animationDuration: 300,
    // }),
    NgxDatatableModule,
    NgxSpinnerModule,
    NgbModule,
    PipeModule
  ]
})
export class StudentLmsModule { }
